@if (appStore.cartError()) {
  <app-alert variant="error" class="m-2">
    We encountered an error while initializing. Please try refreshing the page or contact support if the problem persists.
  </app-alert>
}

<router-outlet/>

<!-- Above CDK modals (z-1000) so loading inside a modal is still covered, below toasts (z-1100) -->
@if (loading.state(); as state) {
  <div class="relative z-[1050]">
    <app-loading-overlay [message]="state.message" [steps]="state.steps"></app-loading-overlay>
  </div>
}
